<script setup lang="ts">

import { ref, watch } from 'vue'

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectLabel,
  SelectItem,
} from "@/components/ui/select"
import { useViewStore } from '@/stores/viewStore'
import { get_data_attr } from '@/utils/globals'

const viewStore = useViewStore();

const props = defineProps({
  rtype: { type: String, default: 'rechtsgrundlagen' },
})

const items = get_data_attr("rechtsaspekt_" + props.rtype);
console.log("Rechtsaspekt items=" + JSON.stringify(items))
const emit = defineEmits(['update:modelValue'])
const selectedRechtsaspekt = ref('')

watch(selectedRechtsaspekt, (newVal) => emit('update:modelValue', newVal))

</script>

<template>
  <div class="hoeppner-bg-white w-32">
	<label for="my-text-input" class="block text-sm font-medium text-gray-700 mb-1">
	  Rechtsaspekt
	</label>
    <Select v-model="selectedRechtsaspekt" >
      <SelectTrigger>
        <SelectValue placeholder="Rechtsaspekte..." />
      </SelectTrigger>
      <SelectContent class="z-[10000]">
        <SelectGroup>
          <SelectLabel>Rechtsaspekt Selektion</SelectLabel>
          <SelectItem
            v-for="item in items"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  </div>
</template>
